<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="../assets/favicon.png" />
      <title>Restó APP</title>
    </head>
    <body class="login">
      <div class="d-flex align-items-center min-vh-100 bg-auth">
        <div class="container">
          <div class="justify-content-center row">
            <div class="my-5 col-xl-4 col-md-5 col-12">
              <h1 class="display-4 text-center mb-3">Cambiar contraseña</h1>
              <form v-on:submit.prevent="changePassword">
                <div class="form-group mb-3">
                  <label class="form-label">Nueva contraseña</label
                  ><input
                    v-model="password"
                    type="password"
                    class="form-control"
                  />
                </div>
                <div class="form-group mb-3">
                  <label class="form-label">Repetir contraseña</label
                  ><input
                    v-model="repeatPassword"
                    type="password"
                    class="form-control"
                  />
                </div>

                <button type="submit" class="w-100 mb-3 btn btn-primary btn-lg">
                  Cambiar contraseña
                </button>
              </form>
              <PopUp :show="success" @close="success = false">
                <template #body>
                  <p>{{ success_msg }}</p>
                </template>
              </PopUp>
              <PopUp :show="error" @close="error = false">
                <template #body>
                  <p>{{ error_msg }}</p>
                </template>
              </PopUp>
            </div>
          </div>
        </div>
      </div>
    </body>
  </html>
</template>

<script>
import PopUp from "../components/PopUp.vue";
import axios from "axios";
export default {
  name: "ResetUser",
  components: {PopUp},
  data: function () {
    return {
      password: "",
      repeatPassword: "",
      error: false,
      success: false,
      error_msg: "",
      success_msg: "",
    };
  },
  methods: {
    changePassword() {
      if (this.password != this.repeatPassword) {
        this.error = true;
        this.error_msg = "Las contraseñas no coinciden";
        return;
      }

      let json = {
        email: this.$route.query.email,
        password: this.password,
        key: this.$route.query.key,
        salt: this.$route.query.salt,
      };

      axios
        .post("/cambio_password-reset-key", json)
        .then((data) => {

          if (data.status == 200) {
            if(data.data.descripcionError){
            this.error = true;
            this.error_msg = data.data.descripcionError;
            }else{
              this.error = false;
            this.success = true;
            this.success_msg = "Contraseña modificada con exito!";
            }

          } else {
            this.error = true;
            
            this.error_msg = data.data.descripcionError;
          }
        });
    },
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
</style>
